export default __webpack_public_path__ + "static/media/chiken-burger.e7692171.jpg";